import React, { useEffect } from "react";
import styled from "styled-components";

const representatives = [
  {
    seller: "Italo Kaio",
    store: "AERA KP",
    location: "Aquiraz/CE",
    contact: "https://wa.me/5585986307151",
  },
  {
    seller: "Valdenor Guerravo Peixoto",
    store: "Valdenor Apoio Downwind",
    location: "Aquiraz/CE",
    contact: "https://wa.me/558591258717",
  },
  {
    seller: "Anderson Firmino",
    store: "Kite Beach Club",
    location: "Aracaju/SE",
    contact: "https://wa.me/5579998073028",
  },
  {
    seller: "Leonardo Mulim Rebello",
    store: "Upwind",
    location: "Araruama/RJ",
    contact: "https://wa.me/5522992668114",
  },
  {
    seller: "Marcelo Villela",
    store: "Buzios Vela Clube BVC",
    location: "Armacao dos Buzios/RJ",
    contact: "https://wa.me/5532988520695",
  },
  {
    seller: "Daniel Filho",
    store: "Kanto do Kite",
    location: "Arpoeiras/CE",
    contact: "https://wa.me/5588998049982",
  },
  {
    seller: "Emerson Franca",
    store: "Indio Guru KP",
    location: "Barra do Cunhau/RN",
    contact: "https://wa.me/5584991258755",
  },
  {
    seller: "Jorge Kitebarratel",
    store: "Kitebarratel",
    location: "Barra do Rio/RN",
    contact: "https://wa.me/5584988192319",
  },
  {
    seller: "Tiago Bahia",
    store: "Barra Grande KP",
    location: "Barra Grande/PI",
    contact: "https://wa.me/5541999819152",
  },
  {
    seller: "Anderson Brito",
    store: "Crispim KP",
    location: "Belem/PA",
    contact: "https://wa.me/5591981816142",
  },
  {
    seller: "Mario da Silva Siqueira Junior",
    store: "Clube Cofeco",
    location: "Cofeco/CE",
    contact: "https://wa.me/5585987819031",
  },
  {
    seller: "Fernando Junior",
    store: "Kitepoeira",
    location: "Cumbuco/CE",
    contact: "https://wa.me/5585987789514",
  },
  {
    seller: "Brinquedo Kite School Brinquedo",
    store: "Brinquedo KP",
    location: "Cumbuco/CE",
    contact: "https://wa.me/5585998004039",
  },
  {
    seller: "Gabriela Lyra",
    store: "Kite Adventure",
    location: "Cumbuco/RN",
    contact: "https://wa.me/554998042256",
  },
  {
    seller: "Junior Pipoca (LPD)",
    store: "Loucos Por Downwind",
    location: "Fortaleza/CE",
    contact: "https://wa.me/5585984017913",
  },
  {
    seller: "David Bernard DPC Fortim",
    store: "DPC Fortim Jaguaribe KP",
    location: "Fortim/CE",
    contact: "https://wa.me/5588981285010",
  },
  {
    seller: "Mikael Santos",
    store: "Mikael Passeios",
    location: "Jeri/CE",
    contact: "https://wa.me/5588998658308",
  },
  {
    seller: "Patrick Kite",
    store: "KSP",
    location: "Mossoro/RN",
    contact: "https://wa.me/5584981490985",
  },
  {
    seller: "Lochen Link",
    store: "No Limits Sports",
    location: "Natal/RN",
    contact: "https://wa.me/5584987522042",
  },
  {
    seller: "Francimario Rufino",
    store: "Maral KP",
    location: "Natal/RN",
    contact: "https://wa.me/5584987584767",
  },
  {
    seller: "Patrick Lopes",
    store: "Patrick Kite",
    location: "Natal/RN",
    contact: "https://wa.me/5584994289597",
  },
  {
    seller: "Ruancelly Barros",
    store: "Ruan Kite",
    location: "Natal/RN",
    contact: "https://wa.me/5584991384640",
  },
  {
    seller: "Harley Peixoto",
    store: "Oficina do Kite",
    location: "Natal/RN",
    contact: "https://wa.me/558498828281",
  },
  {
    seller: "Leopoldo Valentim",
    store: "Barraca Azul KP",
    location: "Pernambuquinho/RN",
    contact: "https://wa.me/5584988406750",
  },
  {
    seller: "Robson Nunes Moreira",
    store: "Robinho Instrutor",
    location: "Porto Alegre/RS",
    contact: "https://wa.me/5551996039558",
  },
  {
    seller: "Rodrigo Palhano",
    store: "Casa Kitesurfers",
    location: "Praia do Futuro/CE",
    contact: "https://wa.me/5585999926059",
  },
  {
    seller: "Mara Ferreira",
    store: "Mara Farma",
    location: "Prea/CE",
    contact: "https://wa.me/5588998367476",
  },
  {
    seller: "Cauane Polo",
    store: "GKC",
    location: "Prea/CE",
    contact: "https://wa.me/5585987601704",
  },
  {
    seller: "Joseildo Jose da Silva",
    store: "Shark Point",
    location: "Recife/PE",
    contact: "https://wa.me/5581995243649",
  },
  {
    seller: "Markus Fabio Ferreira",
    store: "Wind Kite Cofeco",
    location: "Sabiaguaba/CE",
    contact: "https://wa.me/5585996646091",
  },
  {
    seller: "Mario Bustamante",
    store: "Amigos do Vento KP",
    location: "Touros/RN",
    contact: "https://wa.me/5584994686352",
  },
  {
    seller: "Pedro Gamelas",
    store: "Click Nautico Vila Gale",
    location: "Touros/RN",
    contact: "https://wa.me/5584991417875",
  },
  {
    seller: "Alisson Ziemer",
    store: "Vila Velha KP",
    location: "Vila Velha/ES",
    contact: "https://wa.me/554499311018",
  },
];

const Page = styled.main`
  min-height: 100vh;
  background:
    radial-gradient(
      circle at 82% 4%,
      rgba(255, 255, 255, 0.24),
      transparent 28rem
    ),
    linear-gradient(180deg, #0574ff 0%, #005bea 48%, #003cc9 100%);
  color: #ffffff;
  font-family: Montserrat, Arial, sans-serif;
  overflow-x: hidden;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

const Hero = styled.header`
  position: relative;
  max-width: 1180px;
  margin: 0 auto;
  padding: clamp(24px, 5vw, 38px) clamp(14px, 4vw, 22px)
    clamp(20px, 4vw, 28px);

  &::before {
    content: "";
    position: absolute;
    top: -115px;
    right: -95px;
    width: 430px;
    height: 430px;
    border: 42px solid rgba(255, 255, 255, 0.18);
    border-left-color: transparent;
    border-bottom-color: transparent;
    border-radius: 50%;
    transform: rotate(22deg);
  }

  @media (max-width: 640px) {
    padding: 24px 14px 20px;

    &::before {
      top: -92px;
      right: -142px;
      width: 320px;
      height: 320px;
      border-width: 32px;
    }
  }
`;

const LogoWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 214px;
  height: 214px;
  padding: 22px;
  background: #0062ff;
  border-radius: 8px;
  box-shadow: 0 18px 40px rgba(0, 31, 120, 0.2);

  img {
    display: block;
    width: 74px;
    height: auto;
    margin-bottom: 12px;
  }

  span {
    color: #ffffff;
    font-size: 40px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -1px;
  }

  @media (max-width: 640px) {
    width: 156px;
    height: 156px;
    padding: 16px;

    img {
      width: 52px;
      margin-bottom: 10px;
    }

    span {
      font-size: 30px;
    }
  }
`;

const HeroTitle = styled.h1`
  position: relative;
  max-width: 760px;
  margin: 42px 0 14px;
  font-size: clamp(38px, 9vw, 86px);
  line-height: 0.92;
  font-weight: 800;

  @media (max-width: 640px) {
    margin-top: 30px;
  }

  @media (max-width: 380px) {
    font-size: 34px;
  }
`;

const Highlight = styled.span`
  display: inline-block;
  margin-top: 8px;
  padding: 4px clamp(8px, 3vw, 14px) 9px;
  background: #004dff;
`;

const Intro = styled.p`
  position: relative;
  max-width: 620px;
  margin: 0;
  color: rgba(255, 255, 255, 0.88);
  font-size: 19px;
  line-height: 1.45;
  font-weight: 600;

  @media (max-width: 640px) {
    font-size: 16px;
    padding-right: 6px;
  }
`;

const Content = styled.section`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 clamp(14px, 4vw, 22px) 42px;

  @media (max-width: 640px) {
    padding: 0 14px 28px;
  }

  @media (max-width: 380px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const Panel = styled.div`
  position: relative;
  background: rgba(255, 255, 255, 0.96);
  color: #0a2360;
  border-radius: 8px;
  box-shadow: 0 26px 70px rgba(0, 34, 124, 0.24);
  overflow: hidden;
  width: 100%;
`;

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.35fr 0.95fr 160px;
  gap: 16px;
  padding: 18px 22px;
  background: #003dce;
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;

  @media (max-width: 760px) {
    display: none;
  }
`;

const List = styled.div``;

const Row = styled.article`
  display: grid;
  grid-template-columns: 1.2fr 1.35fr 0.95fr 160px;
  gap: 16px;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #dbe6ff;

  &:last-child {
    border-bottom: 0;
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 18px clamp(14px, 4vw, 18px);
  }

  @media (max-width: 380px) {
    padding-left: 12px;
    padding-right: 12px;
  }
`;

const Label = styled.span`
  display: none;
  color: #0062ff;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;

  @media (max-width: 760px) {
    display: block;
    margin-bottom: 3px;
  }
`;

const Seller = styled.strong`
  display: block;
  color: #001f73;
  font-size: 18px;
  line-height: 1.2;
`;

const Text = styled.span`
  display: block;
  color: #24406f;
  font-size: 15px;
  line-height: 1.35;
  font-weight: 650;
`;

const WhatsAppLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 16px;
  border-radius: 8px;
  background: #06c767;
  color: #ffffff;
  font-size: 14px;
  font-weight: 800;
  text-decoration: none;
  box-shadow: 0 10px 22px rgba(6, 199, 103, 0.28);
  transition:
    transform 160ms ease,
    box-shadow 160ms ease,
    background 160ms ease;

  &:hover,
  &:focus {
    background: #05b85f;
    box-shadow: 0 12px 28px rgba(6, 199, 103, 0.34);
    transform: translateY(-1px);
  }

  @media (max-width: 760px) {
    width: 100%;
  }
`;

const Count = styled.div`
  margin: 18px 0 0;
  color: rgba(255, 255, 255, 0.84);
  font-size: 14px;
  font-weight: 700;
`;

const Cell = styled.div`
  min-width: 0;
`;

const Wave = styled.div`
  position: absolute;
  right: -65px;
  bottom: -110px;
  width: 260px;
  height: 260px;
  border: 28px solid rgba(0, 98, 255, 0.08);
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-radius: 50%;
  pointer-events: none;
`;

export default function Representatives() {
  useEffect(() => {
    document.title = "WindRadar - Representantes Comerciais";
  }, []);

  const representativesByLocation = [...representatives].sort((a, b) =>
    a.location.localeCompare(b.location, "pt-BR", { sensitivity: "base" }),
  );

  return (
    <Page>
      <Hero>
        <LogoWrap>
          <img src="Untitled.png" alt="" aria-hidden="true" />
          <span>windradar</span>
        </LogoWrap>
        <HeroTitle>
          Fale com um <Highlight>representante comercial</Highlight>
        </HeroTitle>
        <Intro>
          Lista ordenada pelo nome da Cidade/Estado. Encontre a revenda
          WindRadar mais proxima e chame direto no WhatsApp.
        </Intro>
      </Hero>

      <Content>
        <Panel>
          <TableHeader aria-hidden="true">
            <span>Revendedor</span>
            <span>Revenda</span>
            <span>Localidade</span>
            <span>Contato</span>
          </TableHeader>

          <List>
            {representativesByLocation.map((representative) => (
              <Row key={`${representative.seller}-${representative.store}`}>
                <Cell>
                  <Label>Revendedor</Label>
                  <Seller>{representative.seller}</Seller>
                </Cell>
                <Cell>
                  <Label>Revenda</Label>
                  <Text>{representative.store}</Text>
                </Cell>
                <Cell>
                  <Label>Localidade</Label>
                  <Text>{representative.location}</Text>
                </Cell>
                <Cell>
                  <WhatsAppLink
                    href={representative.contact}
                    aria-label={`Abrir WhatsApp de ${representative.seller}`}
                  >
                    WhatsApp
                  </WhatsAppLink>
                </Cell>
              </Row>
            ))}
          </List>
          <Wave />
        </Panel>
        <Count>{representatives.length} representantes disponiveis</Count>
      </Content>
    </Page>
  );
}
